import styled from "styled-components";
import { SwipeableDrawer, Typography, Button } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";

/* Bottom sheet: sobe de baixo como nos apps nativos e fecha arrastando */
export const Sheet = styled(SwipeableDrawer)`
  & .MuiDrawer-paper {
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    max-height: 90dvh;
    margin: 0 auto;
    border-radius: 20px 20px 0 0;
    overflow-y: auto;
    box-sizing: border-box;
    padding-bottom: env(safe-area-inset-bottom);
  }
`;

export const Handle = styled.div`
  width: 40px;
  height: 5px;
  border-radius: 3px;
  background-color: #dddddd;
  margin: 10px auto 12px;
  flex-shrink: 0;
`;

/* Área fixa 2:1 (a tela não "pula" enquanto a imagem carrega) */
export const BannerFrame = styled.div`
  position: relative;
  width: calc(100% - 32px);
  margin: 0 16px;
  padding-top: calc(50% - 16px);
  border-radius: 12px;
  overflow: hidden;
  background-color: #f2f2f2;
  flex-shrink: 0;
`;

export const BannerImage = styled.img<{ $visible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #ffffff;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.25s ease;
`;

export const ContentWrapper = styled.div`
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
`;

export const CategoryTag = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  background-color: rgba(192, 90, 33, 0.1);
  color: ${theme.colors.base};
  font-size: 12px;
  font-weight: 800;
`;

export const Message = styled(Typography)`
  font-weight: 800 !important;
  color: ${theme.colors.base};
  font-size: 20px !important;
  text-align: center;
  line-height: 1.2 !important;
`;

export const Message2 = styled(Typography)`
  color: #555555;
  font-size: 15px !important;
  text-align: center;
  line-height: 1.5 !important;
  white-space: pre-wrap; /* Respeita quebras de linha do texto */
`;

export const ActionButton = styled.a<{ $color: string }>`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${({ $color }) => $color};
  color: #ffffff;
  padding: 14px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition:
    transform 0.15s ease,
    filter 0.2s ease;

  &:active {
    transform: scale(0.97);
  }

  @media (hover: hover) {
    &:hover {
      filter: brightness(0.93);
    }
  }
`;

export const Confirm = styled(Button)`
  background-color: transparent !important;
  color: #999 !important;
  font-weight: bold !important;
  text-transform: none !important;

  &:hover {
    background-color: #f5f5f5 !important;
  }
`;
